import client from "@/utils/api/client";
import { notFoundWrapper } from "@/utils/notFoundWrapper";
import { ProjectDetailResponse } from "@/web-client/api";
import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import useProject from "@/features/project/hooks/useProject";
import Error from "../_error";
import DefaultLayout from "@/layouts/DefaultLayout";
import ProjectShowTemplate from "@/features/project/components/ProjectShowTemplate";

interface Props {
  id: number;
  initialProject?: ProjectDetailResponse;
}

const ProjectPage: NextPage<Props> = ({ id, initialProject }) => {
  const { project, error } = useProject(id, initialProject);

  if (error) return <Error statusCode={404} label="ページが見つかりません" />;

  if (!project) return <div></div>;

  return (
    <DefaultLayout className="!bg-white">
      <ProjectShowTemplate project={project} />
    </DefaultLayout>
  );
};

export default ProjectPage;

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  return notFoundWrapper<Props>(async () => {
    const id = params.id as string;
    const props: Props = { id: Number(id) };
    try {
      const { data, status } = await client.projectsIdGet(
        { id: Number(params.id) },
        {
          validateStatus(status) {
            return status >= 200 && status < 400;
          },
        },
      );

      if (status === 301) {
        return {
          redirect: {
            destination: `/lists/${data.id}/posts`,
            permanent: true,
          },
        };
      }

      props.initialProject = data;
    } catch (error) {
      if (error.response.status !== 404) {
        throw error;
      }
    }

    return {
      props,
      revalidate: 1,
    };
  });
};

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: "blocking",
});
